<template>
    <div>
        <h2>Relative values</h2>
        <p v-show="best">The trick in this step is to put values or weightings on the definite YES responses relative to each other. </p>
        <p v-show="!best">In this step assign values or weightings to any missing intermediate values relative to the maximum and minimum values</p>
        <form>

            <span v-for="(errorConsideration, errorIndex) in errors.considerations">
              <div v-if="Object.keys(errorConsideration.conditions).length != 0   && (typeof(errorConsideration) != 'undefined')" class="alert alert-warning">
                    <ul>
                        <li v-for="error in errors.considerations">{{ errorConsideration.conditions[0][0] }}</li>
                    </ul>
                </div>
            </span>

         <!--   <div v-if="Object.keys(errors.considerations[0].conditions).length != 0" class="alert alert-warning">
                <ul>
                    <li v-for="error in errors.considerations">{{ error.conditions[0][0] }}</li>
                </ul>
            </div>
-->



            <table class="table border-bottom">
                <tr>
                    <th>Reorder</th>
                    <th>Consideration</th>
                    <th>Condition when I would think differently</th>
                    <th>Value</th>
<!--                    <th></th>-->

                </tr>
                <template v-for="(consideration, considerationIndex) in local.considerations">
                    <tr v-for="(condition, conditionIndex) in local.considerations[considerationIndex].conditions" v-if="(best && conditionIndex == 0) || (!best) ">
                        <td v-if="conditionIndex == 0"
                            :rowspan="best ? 1 : consideration.conditions.length">
                            <i class="fas fa-arrow-up" @click="goUp(considerationIndex)"  v-show="considerationIndex > 0"></i>
                            <i class="fas fa-arrow-down" @click="goDown(considerationIndex)" v-show="considerationIndex < local.considerations.length-1"></i>
                        </td>
                        <td
                            v-if="conditionIndex == 0"
                            :rowspan="best ? 1 : consideration.conditions.length">
                            {{ consideration.name }}
                        </td>
                        <td>
                            {{ condition.name }}
                        </td>
                        <td>
                            <input type="text" class="form-control w-25 d-inline-block" v-model.number="condition.score" v-if="condition.sequence < ConditionTypesEnum.WORST">
                            <input type="text" class="form-control w-25 d-inline-block" v-model.number="condition.score = 0" disabled readonly v-else>


                            <span v-if="conditionIndex == 0">Min: {{ consideration.conditions.length - 1 }}</span>
                            <!--                        TODO: Validate, score must be supplied must be >= #considerations -1-->
                        </td>

<!--                        <td v-if="conditionIndex == 0"
                            :rowspan="best ? 1 : consideration.conditions.length">
                            &lt;!&ndash; show suggested score here &ndash;&gt;
                            <div v-show="considerationIndex == 0" class="alert alert-primary alert-dismissible fade show" role="alert">
                                Your suggested max score is {{suggestedScore}}
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </td>-->
                    </tr>
                </template>
            </table>




            <!--<table class="table border-bottom">
                <tr>
                    <th>Consideration</th>
                </tr>
                <draggable v-model="local.considerations" @start="drag=true" @end="drag=false">
                    <tr v-for="(consideration, considerationIndex) in local.considerations">
                        <td>
                            {{consideration.name}}
                        </td>
                        <td colspan="2">
                            <table class="table table-borderless">

                                <tr>
                                    <th>Condition when I would think differently</th>
                                    <th>Score</th>
                                </tr>

                                <tr v-for="(condition, conditionIndex) in consideration.conditions" v-if="(best && conditionIndex == 0) || (!best)">
                                    <td>{{condition.name}}</td>
                                    <td>
                                        <input type="text" class="form-control w-25 d-inline-block" v-model.number="condition.score" v-if="condition.sequence < ConditionTypesEnum.WORST">
                                        <input type="text" class="form-control w-25 d-inline-block" v-model.number="condition.score = 0" disabled readonly v-else>


                                        <span v-if="conditionIndex == 0">Min: {{ consideration.conditions.length - 1 }}</span>
                                        &lt;!&ndash;                        TODO: Validate, score must be supplied must be >= #considerations -1&ndash;&gt;
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </draggable>
            </table>-->


            <div class="form-group row">
                <button type="button" class="btn btn-success" @click="bestScores" v-show="best">Next</button>
                <button type="button" class="btn btn-success" @click="saveScores" :disabled="!validateScores" v-show="!best">Next</button>
            </div>

            <div class="form-group row">
                <div class="btn-group">

                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import ConditionTypesEnum from '../types/ConditionTypesEnum';
import 'array-move';
const arrayMove = require('array-move');

export default {
    name: 'DefineScores',
    data() {
        return {
            local: {
                considerations: [],
            },
            best: true,
            uncompletedScores: [],
            ConditionTypesEnum: ConditionTypesEnum,
            errors: {
                considerations: [
                    {
                        conditions: {},
                    },
                ],
            },
        };
    },
    computed: {
        ...mapState('data', {
            dataConsiderations: state => state.matrix.considerations,
        }),

        validateScores() {

            this.allScores()

            if(this.uncompletedScores.length > 0) {
                return false
            }else{
                return true
            }
        },

        suggestedScore() {
            //calculate suggested score: number of consideration by 2
            return this.local.considerations.length*2
        }
    },
    methods: {

        ...mapMutations('data', [
            'commitConsiderations',
        ]),

        saveScores() {
            if(this.validateBestScores()) {
                this.commitConsiderations(this.local.considerations);
                this.$router.push({name: 'decisiontable'});
            }
        },

        bestScores() {
            const vm = this;

            if (vm.validateBestScores()) {
                vm.best = false;
                vm.allScores();

            }

        },
        resetErrors() {
            const vm = this;
            vm.$set(vm, 'errors', {
                considerations: [
                    {
                        conditions: {

                        },
                    },
                ],
            });
        },
        setConditionError(considerationIndex, conditionIndex, error) {
            const vm = this;

            let considerations = vm.errors.considerations;
            let payload = {
                [considerationIndex]: {
                    conditions: {
                        [conditionIndex]: [
                            error
                        ]
                    }
                }
            }

            vm.$set(vm.errors, 'considerations', _.merge(considerations, payload));
        },
        validateBestScores() {
            const vm = this;
            vm.resetErrors();

            for (var i in vm.local.considerations) {
                let consideration = vm.local.considerations[i];
                let bestCondition = consideration.conditions[0];
                if (_.isEmpty(bestCondition).score) {
                    vm.setConditionError(i, 0, 'Score must be provided for each condition');
                    return false
                }

                if (!(_.isNumber(bestCondition.score) && (bestCondition.score >= consideration.conditions.length - 1))) {
                    vm.setConditionError(i, 0, 'Score for each condition must be equal or greater than the minimum');
                    return false
                }
            }

            return true
            //return _.isEmpty(vm.errors.considerations[0].conditions);
        },
        allScores() {
            // TODO: Ensure all scores supplied and valid
            // TODO: advance to testing

            const vm = this
            vm.uncompletedScores = []

            _(vm.local.considerations).forEach(function (consideration) {

                _(consideration.conditions).forEach(function (condition) {

                    if(!condition.score && condition.score != '0') {
                        vm.uncompletedScores.push(condition)
                    }
                })

            })
        },

        goUp(index) {
            if(index != 0) {
                this.local.considerations = arrayMove(this.local.considerations, index, index-1);
                this.commitConsiderations(this.local.considerations);
            }

        },

        goDown(index) {
            if(index < this.local.considerations.length -1) {
                this.local.considerations = arrayMove(this.local.considerations, index, index+1);
                this.commitConsiderations(this.local.considerations);
            }
        }
    },
    mounted: function () {
        this.local.considerations = [...this.dataConsiderations];
    },
};
</script>
